import { combineReducers } from "redux";
import Global from "./Global";
import ManageJobs from "./ManageJobs";
import EditJob from "./EditJob";
import ManageNews from './ManageNews'

export default combineReducers({
  Global,
  ManageJobs,
  EditJob,
  ManageNews
});



// WEBPACK FOOTER //
// ./src/redux/index.jsx